const getCountriesStatusSelector = state => state.countries.getCountriesStatus;
const getCountriesSelector = state => state.countries.pool;
export {
    getCountriesStatusSelector,
    getCountriesSelector
}